var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('base-card',[_c('v-card-title',[_vm._v(" Authentication successful... ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }